import Vue from 'vue';
import Vuex from 'vuex';

import { DateTime } from 'luxon';

import api from '@/api';
import universal from './universal';
import station from './station';
import sensorVariable from './sensor-variable';


Vue.use(Vuex);

export default new Vuex.Store({

  strict: 'true',

  modules: {
    universal,
    station,
    sensorVariable,
  },

  state: {

    loading: true,

    timeseries: [],

    dateRange: {
      start: DateTime.local().minus({ days: 0 }).toISODate(),
      end: DateTime.local().toISODate(),
    },

  },

  mutations: {

    setTimeSeries(state, value) {
      state.timeseries = value;
    },

  },

  actions: {

    async getTimeSeries({ commit, state }, params) {
      console.log(params);
      const dateFormat = 'yLLddHHmm';
      const data = await api.getTimeSeries({
        vars: params.vars,
        stids: params.stids,
        start: DateTime.fromISO(params.start).startOf('day').setZone('utc').toFormat(dateFormat),
        end: DateTime.fromISO(params.start).endOf('day').setZone('utc').toFormat(dateFormat),
      });
      commit('setTimeSeries', data);
      return data;
    },

  },

});



// WEBPACK FOOTER //
// ./src/store/index.js